export const dashboardHrMock = {
  kpi: [
    { label: 'Dipendenti/Collaboratori attivi', valore: 28, delta: '+2 nel mese' },
    { label: 'Presenti oggi', valore: 24, delta: '86% presenza' },
    { label: 'Richieste da approvare', valore: 5, delta: '3 urgenti' },
    { label: 'Anomalie aperte', valore: 4, delta: '-1 vs ieri' }
  ],
  presenzeOggi: [
    { dipendente: 'Mario Rossi', prima_entrata: '08:57', ultima_uscita: '-', stato: 'IN_LAVORO', anomalia: '-' },
    { dipendente: 'Lucia Bianchi', prima_entrata: '09:06', ultima_uscita: '-', stato: 'IN_LAVORO', anomalia: 'ingresso_oltre_tolleranza' },
    { dipendente: 'Gianni Verdi', prima_entrata: '08:50', ultima_uscita: '13:05', stato: 'IN_PAUSA', anomalia: '-' },
    { dipendente: 'Sara Neri', prima_entrata: '-', ultima_uscita: '-', stato: 'IN_FERIE', anomalia: '-' }
  ]
};

export const timbraMock = {
  dipendente: 'Mario Rossi',
  stato_giornata: 'IN_LAVORO',
  ultima_timbratura: 'entrata - 08:57',
  riepilogo: {
    ore_lavorate: '03:42',
    ritardo: '00:00',
    profilo: 'Full Time Standard 40h'
  },
  timbrature: [
    { orario: '08:57', tipo: 'entrata', origine: 'web', note: '-' },
    { orario: '13:02', tipo: 'inizio_pausa', origine: 'web', note: '-' },
    { orario: '13:34', tipo: 'fine_pausa', origine: 'web', note: '-' }
  ]
};

export const feriePermessiMock = {
  saldo: {
    ferie_residue: 14.5,
    rol_residui: 22,
    permessi_retribuiti_residui: 12
  },
  richieste: [
    { dipendente: 'Mario Rossi', tipo: 'ferie', periodo: '2026-05-20 -> 2026-05-24', ore: 40, stato: 'inviata' },
    { dipendente: 'Lucia Bianchi', tipo: 'permesso_retribuito', periodo: '2026-04-18', ore: 4, stato: 'approvata' },
    { dipendente: 'Sara Neri', tipo: 'malattia', periodo: '2026-04-15 -> 2026-04-16', ore: 16, stato: 'approvata' },
    { dipendente: 'Gianni Verdi', tipo: 'rol_ex_festivita', periodo: '2026-04-22', ore: 8, stato: 'bozza' }
  ],
  calendario_assenze: [
    { data: '2026-04-18', dipendente: 'Lucia Bianchi', tipo: 'permesso_retribuito' },
    { data: '2026-04-22', dipendente: 'Gianni Verdi', tipo: 'rol_ex_festivita' },
    { data: '2026-05-20', dipendente: 'Mario Rossi', tipo: 'ferie' }
  ]
};

export const presenzeMock = {
  cartellino: [
    { data: '2026-04-10', prima_entrata: '09:00', ultima_uscita: '18:03', ore_lavorate: '08:15', ore_previste: '08:00', stato: 'presente' },
    { data: '2026-04-11', prima_entrata: '09:14', ultima_uscita: '18:01', ore_lavorate: '07:50', ore_previste: '08:00', stato: 'anomalia' },
    { data: '2026-04-12', prima_entrata: '-', ultima_uscita: '-', ore_lavorate: '00:00', ore_previste: '08:00', stato: 'in_ferie' }
  ],
  anomalie: [
    { data: '2026-04-11', tipo: 'ingresso_oltre_tolleranza', gravita: 'media', stato: 'aperta' },
    { data: '2026-04-08', tipo: 'pausa_non_chiusa', gravita: 'alta', stato: 'giustificata' }
  ]
};

export const profiliOrarioMock = {
  profili: [
    { nome: 'Full Time Standard 40h', tipologia: 'fisso', ore_settimanali: 40, flessibile: 'No', attivo: 'Sì' },
    { nome: 'Part Time Mattina 20h', tipologia: 'part_time_mattina', ore_settimanali: 20, flessibile: 'No', attivo: 'Sì' },
    { nome: 'Flessibile Senior', tipologia: 'flessibile', ore_settimanali: 40, flessibile: 'Sì', attivo: 'Sì' }
  ],
  assegnazioni: [
    { dipendente: 'Mario Rossi', profilo: 'Full Time Standard 40h', data_inizio: '2025-01-01', data_fine: '-' },
    { dipendente: 'Lucia Bianchi', profilo: 'Flessibile Senior', data_inizio: '2025-09-01', data_fine: '-' }
  ],
  eccezioni: [
    { dipendente: 'Mario Rossi', data: '2026-04-19', lavorativo: 'No', motivo: 'Permesso personale' },
    { dipendente: 'Gianni Verdi', data: '2026-04-21', lavorativo: 'Sì', motivo: 'Recupero ore' }
  ]
};

export const dipendentiMock = {
  elenco: [
    { matricola: 'DIP-001', nominativo: 'Mario Rossi', reparto: 'Amministrazione', ruolo: 'Impiegato', profilo_orario: 'Full Time Standard 40h', stato: 'attivo' },
    { matricola: 'DIP-002', nominativo: 'Lucia Bianchi', reparto: 'Commerciale', ruolo: 'Account Manager', profilo_orario: 'Flessibile Senior', stato: 'attivo' },
    { matricola: 'DIP-003', nominativo: 'Sara Neri', reparto: 'HR', ruolo: 'HR Specialist', profilo_orario: 'Part Time Mattina 20h', stato: 'non_attivo' }
  ],
  scheda: {
    nome: 'Mario',
    cognome: 'Rossi',
    codice_fiscale: 'RSSMRA85A01H501Z',
    data_nascita: '1985-01-01',
    email: 'mario.rossi@azienda.local',
    telefono: '+39 333 1234567',
    indirizzo: 'Via Roma 10',
    citta: 'Milano',
    matricola: 'DIP-001',
    tipo_contratto: 'tempo_indeterminato',
    data_assunzione: '2021-03-15',
    livello: '3',
    reparto: 'Amministrazione',
    ruolo: 'Impiegato',
    ral: 32000,
    ferie_residue: 14.5,
    rol_residui: 22,
    ritardi_mese: 1,
    anomalie_aperte: 1,
    documenti: [
      { titolo: 'Contratto assunzione', categoria: 'contratto', stato: 'valido', scadenza: '-' },
      { titolo: 'Cedolino Marzo 2026', categoria: 'cedolino', stato: 'archiviato', scadenza: '-' },
      { titolo: 'Certificato sicurezza', categoria: 'certificato', stato: 'da_verificare', scadenza: '2026-12-31' }
    ]
  }
};
